import VisitAssignmentsPage from "./VisitAssignmentsPage";

export default function VisitAssignmentsRoute() {
  return <VisitAssignmentsPage />;
}
